export function shiftMonth(month: string, delta: number): string {
  const [year, monthNum] = month.split('-').map(Number);
  return new Date(Date.UTC(year, monthNum - 1 + delta, 1)).toISOString().slice(0, 10);
}

export function monthLabel(month: string): string {
  const [year, monthNum] = month.split('-').map(Number);
  return new Date(Date.UTC(year, monthNum - 1, 1)).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function currentMonthFirst(): string {
  return `${new Date().toISOString().slice(0, 7)}-01`;
}

export function parseMonth(raw: string | null | undefined): string {
  return raw && /^\d{4}-\d{2}-01$/.test(raw) ? raw : currentMonthFirst();
}
